<template>
    <div class="managerBaseInfoDetailPenetrate">
        <div class="back">
            <div></div>
            <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="goBack">返回</el-button>
        </div>           
        <manager-header :scoreInfo="scoreInfo" :managerInfo="managerInfo" :type="'base'"></manager-header>
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>项目负责人绑定情况</span>
                </div>
            </div>
            <div class="">
                <el-table
                    v-loading="managerBindLoading"
                    :data="managerBindList"
                    ref="multipleTable"
                    tooltip-effect="dark"
                    style="width: 100%;"
                    max-height="300"
                    :header-cell-style="{background:'rgb(241,243,255)'}"
                    stripe
                    border
                    :highlight-current-row="true"
                >
                    <el-table-column label="序号" width="80" type="index" v-bind:index="indexMethod" align="center" ></el-table-column>
                    <el-table-column prop="Name" label="项目负责人" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Mob1" label="手机号码" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.Mob1 ? scope.row.Mob1.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="RoleState" label="项目负责人绑定情况" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.RoleState == 20 ? '已绑定' : '未绑定'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Focus" label="是否关注公众号" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.Focus == 1 ? '已关注' : '未关注'}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 共有资金开户情况 -->
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>共有资金开户情况</span>
                </div>
            </div>
            <div class="">
                <el-table
                    v-loading="commonAccountLoading"
                    :data="commonAccountList"
                    ref="multipleTable"
                    tooltip-effect="dark"
                    style="width: 100%;"
                    max-height="300"
                    :header-cell-style="{background:'rgb(241,243,255)'}"
                    stripe
                    border
                    :highlight-current-row="true"
                >
                    <el-table-column label="序号" width="80" type="index" v-bind:index="indexMethod" align="center" ></el-table-column>
                    <el-table-column prop="Account_type" label="类型" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Account_no" label="登记账户" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Account_openAccountBankName" label="开户银行" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Account_bankName" label="所属银行" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Account_accountName" label="开户名" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Account_registrationTime" label="登记时间" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.Account_registrationTime | formatDate("yyyy-MM-dd")}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 物业合同备案情况 -->
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>物业合同备案情况</span>
                </div>
            </div>
            <div class="">
                <el-table
                    v-loading="contractListLoading"
                    ref="multipleTable"
                    :data="contractList"
                    tooltip-effect="dark"
                    style="width: 100%;"
                    max-height="300"
                    :header-cell-style="{background:'rgb(241,243,255)'}"
                    stripe
                    border
                    :highlight-current-row="true"
                >
                    <el-table-column label="序号" width="80" type="index" v-bind:index="indexMethod" align="center" ></el-table-column>
                    <el-table-column prop="Contract_title" label="物业合同备案情况" align="center" ></el-table-column>
                    <el-table-column prop="Contract_way" label="备案方式" align="center" ></el-table-column>
                    <el-table-column prop="Contract_time" label="备案时间" align="center" >
                        <template slot-scope="scope">
                            {{scope.row.Contract_time | formatDate("yyyy-MM-dd")}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 满意度得分&评价反馈情况 -->
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>满意度得分&评分反馈情况</span>
                </div>
            </div>
            <div class="row">
                <div class="tle">满意度得分</div>
                <div class="tle">满意度排名</div>
                <div class="tle">需要反馈的评价总数</div>
                <!-- <div class="tle">评价总数</div> -->
                <div class="tle">回复数</div>
                <div class="tle">逾期回复数</div>
                <div class="tle">评价反馈率</div>
            </div>
            <div class="row">
                <div class="cnt">{{parseFloat(evaluationData.Eva_score).toFixed(2)}}</div>
                <div class="cnt">{{evaluationData.Eva_cityRank?evaluationData.Eva_cityRank : '--'}}</div>
                <div class="cnt">{{evaluationData.Eva_evaOwnerTotalCount}}</div>
                <!-- <div class="cnt">{{evaluationData.Eva_evaTotalCount}}</div> -->
                <div class="cnt">{{evaluationData.Eva_replyCount}}</div>
                <div class="cnt">{{evaluationData.Eva_lateReplyCount}}</div>
                <div class="cnt">{{Number(evaluationData.Eva_resRate * 100).toFixed(2)}}%</div>
            </div>
            <!-- <template v-else>
                <div style="text-align: center; color: #999; padding: 10px;">暂无数据</div>
            </template> -->
        </div>
        <!-- 信息公开情况 -->
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>信息公开情况</span>
                </div>
            </div>
            <div class="">
                <el-table
                    v-loading="publicInfoLoading"
                    ref="multipleTable"
                    :data="publicInfoList"
                    tooltip-effect="dark"
                    style="width: 100%;"
                    max-height="300"
                    :header-cell-style="{background:'rgb(241,243,255)'}"
                    stripe
                    border
                    :highlight-current-row="true"
                >
                    <el-table-column label="序号" width="80" type="index" v-bind:index="indexMethod" align="center" ></el-table-column>
                    <el-table-column label="应公开次数" align="center" prop="Public_should"></el-table-column>
                    <el-table-column label="实公开次数" align="center" prop="Public_done"></el-table-column>
                    <el-table-column label="信息公开率(%)" align="center" prop="">
                        <template slot-scope="scope">
                            <span v-if="scope.row.Public_should == 0 || scope.row.Public_should == null">100</span>
                            <span v-else>{{((scope.row.Public_done / scope.row.Public_should) * 100).toFixed(2)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 安全检查情况 -->
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>安全检查情况</span>
                </div>
            </div>
            <div class="">
                <el-table
                    v-loading="safeCheckLoading"
                    ref="multipleTable"
                    :data="safeCheckList"
                    tooltip-effect="dark"
                    style="width: 100%;"
                    max-height="300"
                    :header-cell-style="{background:'rgb(241,243,255)'}"
                    stripe
                    border
                    :highlight-current-row="true"
                >
                    <el-table-column label="序号" width="80" type="index" v-bind:index="indexMethod" align="center" ></el-table-column>
                    <el-table-column label="安全检查名称" align="center" prop="SafeCheck_title" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="SafeCheck_type" label="检查类型" align="center" width="150">
                        <template slot-scope="scope">
                            <span v-if="scope.row.SafeCheck_type == 1">常规检查</span>
                            <span v-if="scope.row.SafeCheck_type == 2">专项检查</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="完成情况" align="center" prop="SafeCheck_result" width="150"></el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 通知响应情况 -->
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>通知响应情况</span>
                </div>
            </div>
            <div class="row">
                <div class="tle">接收消息数</div>
                <div class="tle">响应消息数</div>
                <div class="tle">响应率</div>
            </div>
            <template>
                <div class="row">
                    <div class="cnt">{{noticeData.TotalNotices || 0}}</div>
                    <div class="cnt">{{noticeData.ViewNotices || 0}}</div>
                    <div class="cnt">
                        <template>
                            <!-- <span v-if="noticeData.TotalNotices == 0 || noticeData.TotalNotices == null">100%</span>
                            <span v-else>{{ Number((noticeData.ViewNotices / noticeData.TotalNotices) * 100).toFixed(2)}}%</span> -->
                            {{(Number(noticeData.NotificationResponseRate) * 100).toFixed(2)}}
                        </template>
                    </div>
                </div>
            </template>
        </div>
        <!-- 专业能力测评情况 -->
        <div class="basInfo-table model-info bg-w">
            <div class="row">
                <div class="title">
                    <span>专业能力测评情况</span>
                </div>
            </div>
            <div class="">
                <el-table
                    v-loading="trainLoading"
                    ref="multipleTable"
                    :data="trainList"
                    tooltip-effect="dark"
                    style="width: 100%;"
                    max-height="300"
                    :header-cell-style="{background:'rgb(241,243,255)'}"
                    stripe
                    border
                    :highlight-current-row="true"
                >
                    <el-table-column label="序号" width="80" type="index" v-bind:index="indexMethod" align="center" ></el-table-column>
                    <el-table-column label="培训事项" align="center" prop="Train_title"></el-table-column>
                    <el-table-column label="人员姓名" align="center" prop="Train_personName"></el-table-column>
                    <el-table-column label="职务" align="center" prop="Train_detail"></el-table-column>
                    <el-table-column label="考试成绩" align="center" prop="Train_score"></el-table-column>
                    <!-- <el-table-column label="街道名称" align="center" prop="Train_streetName"></el-table-column>
                    <el-table-column label="社区名称" align="center" prop="Train_stationName"></el-table-column>
                    <el-table-column label="物业项目" align="center" prop="Train_eaAreaName"></el-table-column> -->
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import { Page } from '@/models/page';
import filters from '@/filters/index';
import managerHeader from '../components/managerHeader.vue';
import { CreditEvaQueryController } from '@/service/creditEvaQueryController/creditEvaQueryController';
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController';
export default {
    name: 'managerBaseInfoDetailPenetrate',
    components: {
        managerHeader
    },
    data() {
        return {
            mob: '',
            keyId: '',
            managerBindLoading: false,
            managerAccountLoading: false,
            commonAccountLoading: false,
            contractListLoading: false,
            evaluationLoading: false,
            publicInfoLoading: false,
            safeCheckLoading: false,
            noticeLoading: false,
            trainLoading: false,
            scoreInfo: {}, 
            managerInfo: {},
            headerInfo: {},
            managerBindList: [],
            managerAccountList: [],
            commonAccountList: [],
            contractList: [],
            evaluationData: [],
            safeCheckList: [],
            publicInfoList: [],
            noticeData: [],
            trainList: [],
            wyqydm: '',
            pages: new Page(),         
        }
    },
    created() {
        this.CreditEvaQueryController = new CreditEvaQueryController();
        this.CreditInformationController = new CreditInformationController();
        this.wyqydm = this.$route.query.wyqydm;
        this.mob = this.$route.query.mob ? ('' + parseInt(this.$route.query.mob, 16)) : '';
        this.keyId = this.$route.query.keyId || '';
        this.rankId = this.$route.query.rankId || '';
        this.getCreditEvaRanking();
        // 获取头部信息
        this.getCreditEvaInformationVO();
        // 获取项目负责人绑定情况
        this.getManagerPersonRoleByEaAreaCode();
        // 获取共有资金开户列表
        this.getCreditEvaBasicCommonAccountList();
        // 物业合同备案情况
        this.getCreditEvaBasicContractList();
        // 满意度得分
        this.getCreditEvaBasicEvaluationFeedbackInfo();
        // 信息公开情况
        this.getCreditEvaBasicPublic();
        // 安全检查列表
        this.getCreditEvaBasicSafeCheckList();
        // 通知响应情况
        this.getCreditEvaBasicNotice();
        // 专业能力测评
        this.getCreditEvaBasicTrainList();
    },
    methods: {
        indexMethod(index) {
            return (index + 1) + (this.pages.currentPage - 1) * this.pages.currtNum;
        },
        // 获取头部信息 openId:String, token:String, mob:String, orgCode:String, type:String
        getCreditEvaInformationVO() {
            this.CreditEvaQueryController.getCreditEvaInformationVO_builtBureauWebsite(
                this.mob,
                '',
                1
            ).then(res => {
                if(res) {
                    this.managerInfo = res;
                }
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 获取头部分数信息 keyId:String, dateTime:Date, bodyType:int, type:int
        getCreditEvaRanking() {
            let timeNow = filters.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
                this.CreditEvaQueryController.getCreditEvaRanking_builtBureauWebsite(
                    this.rankId,
                    timeNow,
                    2,
                    1
                ).then(res => {
                    if(res) {
                        this.scoreInfo= res;
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: err.Msg
                    });
                });
        },        
        // 获取负责人绑定 token:String, wyqydm:String, startIndex:int, maxSize:int
        getManagerPersonRoleByEaAreaCode() {
            this.managerBindLoading = true;
            this.CreditEvaQueryController.getManagerPersonRoleByEaAreaCode_builtBureauWebsite(
                this.wyqydm,
                0,
                9999
            ).then(res => {
                this.managerBindLoading = false;
                if(res && res._Items) {
                    this.managerBindList = res._Items;
                }
            }).catch(err => {
                this.managerBindLoading = false;
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 获取共有资金开户列表  token:String, wyqydm:String, startIndex:int, maxSize:int
        getCreditEvaBasicCommonAccountList() {
            this.commonAccountLoading = true;
            this.CreditEvaQueryController.getCreditEvaBasicCommonAccountList_builtBureauWebsite(
                this.wyqydm,
                0,
                9999
            ).then(res => {
                this.commonAccountLoading = false;
                if(res && res._Items) {
                    this.commonAccountList = res._Items;
                }
            }).catch(err => {
                this.commonAccountLoading = false;
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 物业合同备案情况  token:String, wyqydm:String, startIndex:int, maxSize:int
        getCreditEvaBasicContractList() {
            this.contractListLoading = true;
            this.CreditEvaQueryController.getCreditEvaBasicContractList_builtBureauWebsite(
                this.wyqydm,
                0,
                9999
            ).then(res => {
                this.contractListLoading = false;
                if(res && res._Items) {
                    this.contractList = res._Items;
                }
            }).catch(err => {
                this.contractListLoading = false;
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 满意度得分&评分反馈情况  token:String, wyqydm:String, startIndex:int, maxSize:int
        getCreditEvaBasicEvaluationFeedbackInfo() {
            this.CreditEvaQueryController.getCreditEvaBasicEvaluationFeedbackInfo(
                this.wyqydm
            ).then(res => {
                if(res){
                    this.evaluationData = res;
                }
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 信息公开情况  token:String, wyqydm:String
        getCreditEvaBasicPublic() {
            this.publicInfoLoading = true;
            this.CreditEvaQueryController.getCreditEvaBasicPublic_builtBureauWebsite(
                this.wyqydm,
            ).then(res => {
                this.publicInfoLoading = false;
                if(res) {
                    this.publicInfoList.push(res);
                }
            }).catch(err => {
                this.publicInfoLoading = false;
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 安全检查情况  token:String, wyqydm:String, startIndex:int, maxSize:int
        getCreditEvaBasicSafeCheckList() {
            this.safeCheckLoading = true;
            this.CreditEvaQueryController.getCreditEvaBasicSafeCheckList_builtBureauWebsite(
                this.wyqydm,
                0,
                9999
            ).then(res => {
                this.safeCheckLoading = false;
                if(res && res._Items) {
                    this.safeCheckList = res._Items;
                }
            }).catch(err => {
                this.safeCheckLoading = false;
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 通知相应情况  token:String, wyqydm:String, startIndex:int, maxSize:int
        getCreditEvaBasicNotice() {
            this.CreditEvaQueryController.getCreditEvaBasicNotice_builtBureauWebsite(
                this.wyqydm
            ).then(res => {
                if(res){
                    this.noticeData = res;
                }
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 专业能力测评情况  token:String, wyqydm:String, startIndex:int, maxSize:int
        getCreditEvaBasicTrainList() {
            this.trainLoading = true;
            this.CreditEvaQueryController.getCreditEvaBasicTrainList_builtBureauWebsite(
                this.wyqydm,
                0,
                9999
            ).then(res => {
                this.trainLoading = false;
                if(res && res._Items) {
                    this.trainList = res._Items;
                }
            }).catch(err => {
                this.trainLoading = false;
                this.$message({
                    type: 'error',
                    message: err.Msg
                });
            });
        },
        // 返回
        goBack(){
            this.$router.back()
        },
    }
}
</script>

<style lang="scss" scoped>
.managerBaseInfoDetailPenetrate{
    .back{
        display: flex;
        justify-content: space-between;
    }
    width: 100%;
    height: 800px;
    box-sizing: border-box;
    padding: 10px;
    .header-box{
        width: 100%;
        height: 100px;
        padding: 20px 30px;
        box-sizing: border-box;
        border-radius: 10px;
        box-shadow: 0 0 5px #7e7e7e;
        margin-bottom: 30px;
        line-height: 30px;
        .info-box{
            .name{
                margin-right: 40px;
            }
        }
    }
    .model-info {
        .row {
            .total-box{
                box-sizing: border-box;
                padding: 5px 15px;
                margin-left: 10px;
                background: #1890ff;
                color: #fff;
                border-radius: 5px;
            }
            .link {
                color: #1890ff;
                cursor: pointer;
            }
            .more-data{
                float: right;
            }
        }
    }
}
</style>